// TODO: remove after F1-1939
// eslint-disable-next-line
import { LinkSystem } from "@benefit-systems/hr-tools-ui";

import restUrls from "web/constants/restUrls";

import api from "../api/apiSlice";

interface ProcessedMenuItem {
  code: string;
  label?: string | null;
  url?: string | null;
  baseUrl?: string | null;
  path?: string | null;
  system?: string | null;
  target: string;
  items: ProcessedMenuItem[];
}

export interface IDashboardHeaderDataResponse {
  pointsBank: {
    balance: string;
  };
  mainMenu: {
    baseUrl: string;
    path: string;
    system: LinkSystem;
    code?: string;
    label: string;
    url?: string;
    target?: string;
    items?: {
      code: string;
      label: string;
      url: string;
      target: string;
    }[];
  }[];
  productsMenu: {
    label: string;
    items: {
      baseUrl: string;
      path: string;
      system: LinkSystem;
      code: string;
      label: string;
      url: string;
      target: string;
    }[];
  }[];
  profileMenu: {
    label: string;
    items: {
      baseUrl: string;
      path: string;
      system: LinkSystem;
      code: string;
      label: string;
      url: string;
      target: string;
    }[];
  }[];
  footerMenu: {
    label: string;
    items: {
      code: string;
      label: string;
      url: string;
      target: string;
    }[];
  }[];
  employee: {
    firstName: string;
    lastName: string;
    email: string;
    language: string;
  };
  employeeStructureData: {
    initials: string;
    avatar: { optimized: string; original: string } | null;
  };
  products: {
    code: string;
    name: string;
    isAvailable: boolean;
  }[];
  notifications: {
    qty: number;
  };
  logo: {
    companyName: string;
    src: string;
    url: string;
  };
  userMenu: ProcessedMenuItem[];
}

export const dashboardHeaderApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardHeaderData: builder.query<IDashboardHeaderDataResponse, void>({
      query: () => ({
        url: restUrls.dashboardHeader,
      }),
      providesTags: ["DashboardHeaderData"],
    }),
  }),
});

export const { useGetDashboardHeaderDataQuery } = dashboardHeaderApiSlice;
